import { ApplicationInsights } from '@microsoft/applicationinsights-web';
var appInsightsInstance;
export function getAppInsights() {
    var connectionString = "";
    if (location.host.indexOf("localhost") !== -1) {
        console.debug("** appInsights.ts Local Mode **");
        return appInsightsInstance;
    }
    else if (location.host.indexOf("skillbuilder-uat.com") !== -1) {
        connectionString = "InstrumentationKey=3c0a2c7a-9df0-4fc4-9551-053e36b14e82;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/;ApplicationId=6d685d86-1613-47f5-bac8-9d6d614430fa";
        console.debug("** appInsights.ts Dev Mode **");
    }
    else {
        connectionString = "InstrumentationKey=667006c3-8994-4dc5-bf7f-c2ddda63339f;IngestionEndpoint=https://canadacentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://canadacentral.livediagnostics.monitor.azure.com/;ApplicationId=9e752654-88be-49fa-b14a-1890c0926cbb";
        console.debug("** appInsights.ts Prod Mode **");
    }
    if (!appInsightsInstance) {
        appInsightsInstance = new ApplicationInsights({
            config: {
                connectionString: connectionString
            }
        });
        appInsightsInstance.loadAppInsights();
    }
    return appInsightsInstance;
}
